import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import Heading from '../../../../components/Heading';
import Amount from '../../../../components/Amount';
import OrderPreview from '../../../../components/OrderPreview';

// Styles
import styles from './Cart.styl';
import { fetchUpsale } from '../../../../state/modules/catalog/actions';
import { useDispatch, useSelector } from 'react-redux';
import { priceIncludingBonusesSelector } from '../../../../state/modules/order/selectors';

const cx = classNames.bind(styles);

export default function Cart(props) {
  const {
    orderData: { cart, price_with_stock },
  } = props;

  const intl = useIntl();

  return (
    <div className={cx('Cart')}>
      <Heading className={cx('Cart__title')} level={3}>
        {intl.formatMessage({ id: 'cart.title' })}
        <span className={cx('Cart__count')}>{` (${cart.composition.length})`}</span>
      </Heading>
      <OrderPreview className={cx('Cart__preview')} items={cart.composition} />
      <div className={cx('Cart__total')}>
        {intl.formatMessage({ id: 'label.total' })}
        :&nbsp;
        <Amount
          className={cx('Cart__amount')}
          value={cart.price}
          newValue={price_with_stock - (cart.sailplay_discount || 0)}
        />
      </div>
    </div>
  );
}

Cart.propTypes = {
  orderData: PropTypes.object.isRequired,
};
